import { Injectable } from '@angular/core';
import { CacheService } from './cache.service';

@Injectable({
    providedIn: 'root'
})
export class MigrationService {
    private migrationKeys = [
        'formFields',
        'formNames',
        'user-list',
        'last-insert',
        'last-insert-samples',
        'last-insert-lithology',
        'last-insert-geotech',
        'last-insert-structures',
        'last-insert-density'
    ];

    constructor(private cacheService: CacheService) { }

    async migrateFromLocalStorageToIndexedDB(): Promise<void> {
        console.log('Iniciando migração do localStorage para IndexedDB...');

        for (const key of this.migrationKeys) {
            try {
                const value = localStorage.getItem(key);
                if (value) {
                    let parsedValue;
                    try {
                        parsedValue = JSON.parse(value);
                    } catch {
                        parsedValue = value;
                    }

                    // Migra para o sistema de cache inteligente
                    await this.cacheService.setItem(key, parsedValue);

                    // Remove do localStorage apenas as chaves que não devem ficar lá
                    if (!this.shouldStayInLocalStorage(key)) {
                        localStorage.removeItem(key);
                    }

                    console.log(`Migração concluída para: ${key}`);
                }
            } catch (error) {
                console.error(`Erro ao migrar ${key}:`, error);
            }
        }

        // Migra também report-users baseados no padrão
        this.migrateReportUsers();

        // Marca como migração concluída
        localStorage.setItem('migration-completed', 'true');
        console.log('Migração completa!');
    }

    private async migrateReportUsers(): Promise<void> {
        const reportUserKeys = Object.keys(localStorage).filter(key =>
            key.startsWith('report-users-')
        );

        for (const key of reportUserKeys) {
            try {
                const value = localStorage.getItem(key);
                if (value) {
                    const parsedValue = JSON.parse(value);
                    await this.cacheService.setItem(key, parsedValue);
                    localStorage.removeItem(key);
                    console.log(`Migração concluída para: ${key}`);
                }
            } catch (error) {
                console.error(`Erro ao migrar ${key}:`, error);
            }
        }
    }

    private shouldStayInLocalStorage(key: string): boolean {
        const localStorageKeys = [
            'kc-token',
            'kc-refresh-token',
            'kc-user-info',
            'kc-expires-at',
            'access-token',
            'refresh-token',
            'user-info',
            'user-credentials',
            'auth-info',
            'keycloak-token'
        ];

        return localStorageKeys.some(lsKey => key.includes(lsKey) || key.startsWith(lsKey));
    }

    shouldRunMigration(): boolean {
        return localStorage.getItem('migration-completed') !== 'true';
    }

    async clearOldData(): Promise<void> {
        // Remove dados antigos que não são mais necessários no localStorage
        for (const key of this.migrationKeys) {
            if (!this.shouldStayInLocalStorage(key)) {
                localStorage.removeItem(key);
            }
        }

        // Remove report-users do localStorage
        const reportUserKeys = Object.keys(localStorage).filter(key =>
            key.startsWith('report-users-')
        );

        for (const key of reportUserKeys) {
            localStorage.removeItem(key);
        }
    }
}
